define('common/ko/extension/async',['knockout'], function (ko) {
    ko.extenders.async = function(source, defaultValue) {
        var target = ko.observable(), currentDeferred;
        target.inProgress = ko.observable(false); // Track whether we're waiting for a result

        ko.computed(function() {
            if(ko.isObservable(defaultValue)) {
                target(defaultValue());
            } else {
                // Abort any in-flight evaluation to ensure we only notify with the latest value
                if (currentDeferred) { currentDeferred.reject(); }

                var evaluatorResult = source.call(target);
                // Cope with both asynchronous and synchronous values
                if (evaluatorResult && (typeof evaluatorResult.done === 'function')) { // Async
                    target.inProgress(true);
                    currentDeferred = $.Deferred().done(function(data) {
                        target(data);
                        target.inProgress(false);
                    });
                    evaluatorResult.done(currentDeferred.resolve);
                } else { // Sync
                    target(evaluatorResult);
                }
            }
        });

        return target;
    };
});

